import React from "react";
import { Modal, Button } from "react-bootstrap";

const CompleteTaskModal = ({
    show,
    close,
    onSubmit,
}) => {
    return (
        <Modal
            show={show}
            onHide={close}
            centered
            backdrop="static"
        >
            <Modal.Header
                closeButton
                className="mngmodelheader"
            >
                <Modal.Title>
                    <h5>Complete Task</h5>
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <p className="mb-0">
                    Are you sure you want to complete this task?
                </p>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    className="primaryBtn"
                    onClick={onSubmit}
                >
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CompleteTaskModal;